export const GET_UPDATE_ASSESSOR = 'GET_UPDATE_ASSESSOR';
export const SET_UPDATE_ASSESSOR = 'SET_UPDATE_ASSESSOR';

export const GET_DELETE_ASSESSOR = 'GET_DELETE_ASSESSOR';
export const SET_DELETE_ASSESSOR = 'SET_DELETE_ASSESSOR';

export const SET_UPDATE_ASSESSOR_IN_EVALUATION = 'SET_UPDATE_ASSESSOR_IN_EVALUATION';
export const SET_DELETE_ASSESSOR_IN_EVALUATION = 'SET_DELETE_ASSESSOR_IN_EVALUATION';
